import {
  Footer,
  HeaderBanner,
  PitchBasis,
  PitchBS,
  PitchBV,
  PitchCapex,
  PitchCF,
  PitchDB,
  PitchFeasibility,
  PitchIS,
  PitchMain,
  Content,
  PitchOpex,
  PrimaryTabs,
  MainHeader,
} from "components";
import React, { useEffect } from "react";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaApple } from "react-icons/fa";
import cms from "../../services/cms";
import CustomHelmet from "../../components/CustomHelmet";
import { useParams } from "react-router-dom";

const InvestorsPitch = () => {
  const { lang: _lang, id } = useParams();
  const lang = _lang || "en";
  const tabs = [
    "Content",
    "Investor’s Pitch",
    "DB",
    "IS",
    "CF’s",
    "BS",
    "Feasibility",
    "BV",
    "Basis",
    "Capex",
    "Opex",
  ];
  const [seos, setSeos] = useState({});
  const [active, setActive] = useState('Content');
  const fetchSeo = async () => {
    const res = await cms.getSeo("investors-pitch");
    setSeos(res?.data?.data);
  };

  const [showDropdown, setShowDropdown] = useState(false);
  useEffect(() => {
    if(id)
    {
      if (id == "Investor’s-Pitch") {
        setActive("Investor’s Pitch")
      }
      else {
        setActive(id)
      }
    }
   
  }, [id])

  useEffect(() => {
    (async () => {
      await fetchSeo();
    })();
  }, []);


  return (
    <>
      <main className="investors-pitch grey-bg" onClick={()=>{ if(showDropdown) setShowDropdown(!showDropdown)}}>
      <MainHeader showDropdown={showDropdown} setShowDropdown={setShowDropdown}  />
    
        <HeaderBanner />
        {seos && seos?.seos ? (
          <CustomHelmet seo={seos?.seos} lang={lang} />
        ) : (
          ""
        )}
        <div className="bottom-solid pt-3">
          <PrimaryTabs active={active} setActive={setActive} tabs={tabs} />
        </div>
        {tabs[0] == active && (
          <>
            <Content />
          </>
        )}
        {tabs[1] == active && (
          <>
            <PitchMain />
          </>
        )}
        {tabs[2] == active && (
          <>
            <PitchDB />
          </>
        )}
        {tabs[3] == active && (
          <>
            <PitchIS />
          </>
        )}
        {tabs[4] == active && (
          <>
            <PitchCF />
          </>
        )}
        {tabs[5] == active && (
          <>
            <PitchBS />
          </>
        )}
        {tabs[6] == active && (
          <>
            <PitchFeasibility />
          </>
        )}
        {tabs[7] == active && (
          <>
            <PitchBV />
          </>
        )}
        {tabs[8] == active && (
          <>
            <PitchBasis />
          </>
        )}
        {tabs[9] == active && (
          <>
            <PitchCapex />
          </>
        )}
        {tabs[10] == active && (
          <>
            <PitchOpex />
          </>
        )}
      </main>
      <Footer />
    </>
  );
};

export default InvestorsPitch;
